var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _circle, _path23, _path24;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransitionRate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 86,
    height: 86,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 86 86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".c{fill:#27a2db;}.d{fill:#fff;}.e{fill:#fcd462;}.f{fill:#e56353;}.g{fill:#3a556a;}.h{fill:url(#b);opacity:.35;}.i{fill:#44c4a1;}.j{fill:#ebf0f3;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 39.91,
    y1: 80.19,
    x2: 47.91,
    y2: 3.69,
    gradientTransform: "translate(0 86) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#19ff55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007f0f"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m.77,31.66C.77,20.46.77,14.86,2.95,10.58,4.86,6.82,7.92,3.76,11.69,1.84,15.96-.34,21.56-.34,32.77-.34h22c11.2,0,16.8,0,21.08,2.18,3.76,1.92,6.82,4.98,8.74,8.74,2.18,4.28,2.18,9.88,2.18,21.08v22c0,11.2,0,16.8-2.18,21.08-1.92,3.76-4.98,6.82-8.74,8.74-4.28,2.18-9.88,2.18-21.08,2.18h-22c-11.2,0-16.8,0-21.08-2.18-3.76-1.92-6.82-4.98-8.74-8.74-2.18-4.28-2.18-9.88-2.18-21.08v-22Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m56.21,9.68H20.53c-2.13,0-3.85,1.73-3.85,3.86v58.93c0,2.13,1.73,3.85,3.86,3.85h44.92c2.13,0,3.85-1.72,3.86-3.85V22.84l-13.11-13.15Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m60.06,22.84h9.24l-13.09-13.15v9.25c-.02,2.13,1.68,3.88,3.81,3.9.01,0,.02,0,.04,0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m64.83,65.15l-3.71-1.67v1.18H25.65v-28.13h1.18l-1.67-3.71-1.67,3.71h1.18v29.1h36.43v1.18l3.71-1.67Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m22.09,38.2h1.62v.83h-1.62v-.83Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m22.09,41.11h1.62v.83h-1.62v-.83Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m22.09,44.03h1.62v.83h-1.62v-.83Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m22.09,46.95h1.62v.83h-1.62v-.83Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m22.09,49.87h1.62v.83h-1.62v-.83Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m22.09,52.78h1.62v.83h-1.62v-.83Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m22.09,55.7h1.62v.83h-1.62v-.83Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m22.09,58.62h1.62v.83h-1.62v-.83Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m22.09,61.54h1.62v.83h-1.62v-.83Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m22.09,64.44h1.62v.83h-1.62v-.83Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m28.69,45.56h4.71v19.11h-4.71v-19.11Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "m35.36,48.34h4.71v16.34h-4.71v-16.34Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m42.04,42.47h4.71v22.19h-4.71v-22.19Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "m48.72,47.77h4.71v16.89h-4.71v-16.89Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m55.39,52.78h4.71v11.88h-4.71v-11.88Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m59.65,45.9h-.12l-8.55-3.33-.12-.09-6.45-6.74-7.89,7.17c-.1.09-.24.11-.36.07l-7.53-2.92c-.18-.07-.26-.27-.19-.44,0,0,0,0,0,0,.06-.17.26-.26.43-.2,0,0,0,0,.01,0l7.34,2.84,8.02-7.25c.13-.13.34-.13.47,0l6.63,6.93,8.47,3.31c.17.06.26.26.2.43,0,0,0,0,0,.01-.05.14-.19.23-.34.22Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m36.2,40.7c-.87,0-1.58.71-1.58,1.58s.71,1.58,1.58,1.58,1.58-.71,1.58-1.58h0c0-.88-.7-1.58-1.57-1.58h0Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m44.39,33.91c-.87,0-1.58.71-1.58,1.58s.71,1.58,1.58,1.58,1.58-.71,1.58-1.58c0-.87-.71-1.57-1.58-1.58Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m28.35,37.96c-.87,0-1.58.71-1.58,1.58s.71,1.58,1.58,1.58,1.58-.71,1.58-1.58-.71-1.58-1.58-1.58Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m51.07,40.37c-.87,0-1.58.71-1.58,1.58s.71,1.58,1.58,1.58,1.58-.71,1.58-1.58c0-.87-.71-1.57-1.58-1.58Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 59.39,
    cy: 45.42,
    r: 1.58
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "m39.36,26.75h-9.23v5.35h3.19l1.42,2.37,1.28-2.37h3.33v-5.35Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "m58.03,31.04h-9.22v5.35h3.18l1.43,2.37,1.27-2.37h3.33v-5.35Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransitionRate);
export default __webpack_public_path__ + "static/media/transition_rate.99e34d527f0fa1e6f58fb94a21e4847f.svg";
export { ForwardRef as ReactComponent };